/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { LoginPayload, LoginResponse } from './types';
import { apiClient } from '@/utils/apiClient';
import { extractErrorMessage } from '@/utils/errorHandling';

export const postLogin = createAsyncThunk<
  LoginResponse, // returned value type
  LoginPayload, // first arg to the payload creator
  { rejectValue: string } // thunkAPI.rejectWithValue type
>('login/postLogin', async (payload, { rejectWithValue }) => {
  try {
    const response = await apiClient('/auth/api/v1/login//', {
      method: 'POST',
      body: payload,
    });
    return response as LoginResponse;
  } catch (err: unknown) {
    // apiClient throws an ApiError whose .message is already formatted by
    // formatApiError (handles {detail}, {error: [...]}, DRF field errors, etc.).
    // Prefer that; fall back to raw payload fields for any non-ApiError throw.
    return rejectWithValue(extractErrorMessage(err, 'Login failed'));
  }
});
